import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export interface Toast {
  id: number;
  text: string;
  kind: 'success' | 'error' | 'info';
}

/**
 * Short-lived confirmation messages ("Task saved"), rendered by ToastContainerComponent.
 */
@Injectable({providedIn: 'root'})
export class ToastService {

  private nextId = 1;
  readonly toasts$ = new BehaviorSubject<Toast[]>([]);

  success(text: string) {
    this.show(text, 'success');
  }

  error(text: string) {
    this.show(text, 'error', 6000);
  }

  info(text: string) {
    this.show(text, 'info');
  }

  dismiss(id: number) {
    this.toasts$.next(this.toasts$.value.filter(toast => toast.id !== id));
  }

  private show(text: string, kind: Toast['kind'], durationMs = 3000) {
    const toast = {id: this.nextId++, text, kind};
    this.toasts$.next([...this.toasts$.value, toast]);
    setTimeout(() => this.dismiss(toast.id), durationMs);
  }
}
